/**
 * Conflito (US-1774): o mesmo fornecedor com duas ou mais alocações cujos
 * intervalos se sobrepõem, desconsiderando obras canceladas. As datas são
 * inclusivas — uma alocação que termina no mesmo dia em que outra começa
 * conflita; dias consecutivos não conflitam. Cada par sobreposto conta um conflito.
 * Usado pelos filtros ("Com conflito"); o Gantt calcula os seus (o de Profissionais).
 */

export interface IntervaloAlocacao {
  id: string;
  inicio: string;
  fim: string;
  cancelada: boolean;
}

export interface Conflito {
  /** Ids das duas alocações sobrepostas. */
  alocacoes: [string, string];
  /** Trecho sobreposto, inclusivo. */
  inicio: string;
  fim: string;
}

function isValidInterval(item: IntervaloAlocacao): boolean {
  return item.inicio !== "" && item.fim !== "" && item.inicio <= item.fim;
}

/** Pares de alocações sobrepostas de um mesmo fornecedor (canceladas ignoradas). */
export function findConflitos(alocacoes: IntervaloAlocacao[]): Conflito[] {
  const ativas = alocacoes
    .filter((item) => !item.cancelada && isValidInterval(item))
    .sort((a, b) => a.inicio.localeCompare(b.inicio));
  const conflitos: Conflito[] = [];

  for (let i = 0; i < ativas.length; i += 1) {
    const a = ativas[i] as IntervaloAlocacao;

    for (let j = i + 1; j < ativas.length; j += 1) {
      const b = ativas[j] as IntervaloAlocacao;
      // Ordenadas pelo início: a partir daqui nenhuma outra começa antes do fim de `a`.
      if (b.inicio > a.fim) break;

      conflitos.push({
        alocacoes: [a.id, b.id],
        inicio: b.inicio,
        fim: a.fim < b.fim ? a.fim : b.fim,
      });
    }
  }

  return conflitos;
}
